import api, { buildUrl } from 'services/api';
import { GET, POST, adminRoutes, DELETE, PUT } from 'constants/api';
import { USER_ROLES } from 'constants/auth';

const checkParam = param => {
  if (!param) throw new Error(`${param} is missing`);
};

const checkRole = role => {
  if (!USER_ROLES.hasOwnProperty(role))
    throw new Error('User Role is incorrect');
};

export const createUser = data =>
  api({
    method: POST,
    url: adminRoutes.CREATE_USER,
    data,
  });

export const getTotalUsers = ({ search, role }) =>
  api({
    method: GET,
    url: adminRoutes.GET_TOTAL_USERS,
    params: { search, role },
  }).then(data => data.total);

export const getUsers = ({ page, limit, search, role }) =>
  api({
    method: GET,
    url: adminRoutes.GET_USERS,
    params: { page, limit, search, role },
  });

export const updateUser = data => {
  checkParam(data.user_id);
  return api({
    method: POST,
    url: adminRoutes.UPDATE_USER,
    data,
  });
};

export const updateUserRole = data => {
  checkParam(data.user_id);
  checkRole(data.role);
  return api({
    method: POST,
    url: adminRoutes.UPDATE_USER_ROLE,
    data,
  });
};

export const resetUserPassword = data => {
  checkParam(data.user_id);
  checkParam(data.password);
  return api({
    method: POST,
    url: adminRoutes.RESET_USER_PASSWORD,
    data,
  });
};

export const deleteUser = data => {
  checkParam(data.user_id);
  return api({
    method: DELETE,
    url: `${adminRoutes.DELETE_USER}${data.user_id}`,
    id: data.user_id,
  });
};

export const getUser = (userId: number) => {
  return api({
    method: GET,
    url: adminRoutes.GET_USER(userId),
  });
};

export const listDedicatedIps = () => {
  return api({
    method: GET,
    url: `${adminRoutes.LIST_DEDICATED_IP}`,
  });
};

export const createDedicatedIp = ({ ip, esp }) => {
  return api({
    method: POST,
    url: `${adminRoutes.CREATE_DEDICATED_IP}`,
    data: { ip, esp },
  });
};

export const syncDedicatedIp = () => {
  return api({
    method: POST,
    url: `${adminRoutes.SYNC_DEDICATED_IP}`,
  });
};

export const deleteDedicatedIp = id => {
  return api({
    method: DELETE,
    url: `${adminRoutes.DELETE_DEDICATED_IP}${id}`,
  });
};

export const listAllDomainMonitoring = () => {
  return api({
    method: GET,
    url: `${adminRoutes.LIST_DOMAIN_MONITORING}`,
  });
};

export const createDomainMonitoring = ({ domain }) => {
  return api({
    method: POST,
    url: `${adminRoutes.CREATE_DOMAIN_MONITORING}`,
    data: { domain },
  });
};

export const deleteDomainMonitoring = id => {
  return api({
    method: DELETE,
    url: `${adminRoutes.DELETE_DOMAIN_MONITORING}${id}`,
  });
};

export const submitBugFeature = data => {
  return api({
    method: POST,
    url: adminRoutes.SUBMIT_BUG_FEATURE,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateBugFeatureStatus = ({ id, ...data }) => {
  return api({
    method: PUT,
    url: adminRoutes.UPDATE_BUG_FEATURE_STATUS(id),
    data,
  });
};

export const listBugFeature = query => {
  return api({
    method: GET,
    url: buildUrl({ url: adminRoutes.LIST_BUG_FEATURE, query }),
  });
};

export const getOneBugFeature = id => {
  return api({
    method: GET,
    url: adminRoutes.GET_ONE_BUG_FEATURE(id),
  });
};

export const getBugFeatureStatistics = () => {
  return api({
    method: GET,
    url: adminRoutes.GET_BUG_FEATURE_STATISTICS,
  });
};

export const getBugFeatureAttachmentUrl = id => {
  return api({
    method: GET,
    url: adminRoutes.GET_BUG_FEATURE_ATTACHMENT_URL(id),
  });
};

export const getAuthorizedDomains = () => {
  return api({
    method: GET,
    url: adminRoutes.GET_AUTHORIZED_DOMAINS,
  });
};

export const addAuthorizedDomain = domain => {
  return api({
    method: POST,
    url: adminRoutes.ADD_AUTHORIZED_DOMAIN,
    data: domain,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateAuthorizedDomain = ({ id, formData }) => {
  return api({
    method: PUT,
    url: adminRoutes.UPDATE_AUTHORIZED_DOMAIN(id),
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getSIBDomains = () => {
  return api({
    method: GET,
    url: adminRoutes.GET_SIB_DOMAINS,
  });
};

export const addSIBDomain = domain => {
  return api({
    method: POST,
    url: adminRoutes.ADD_SIB_DOMAIN,
    data: domain,
  });
};

export const updateSIBDomain = ({ id, data }) => {
  return api({
    method: PUT,
    url: adminRoutes.UPDATE_SIB_DOMAIN(id),
    data,
  });
};

export const deleteSIBDomain = (id) => {
  return api({
    method: DELETE,
    url: adminRoutes.DELETE_SIB_DOMAIN(id),
  });
};

